export const locales = {
  ru: {
    locale: 'ru-RU',
    decimalSeparator: ',',
    dateFormat: 'YYYY-MM-DD, HH:mm:ss',
    dateFormatWithoutTime: 'YYYY-MM-DD'
  },
  en: {
    locale: 'en-EN',
    decimalSeparator: '.',
    dateFormat: 'YYYY-MM-DD, HH:mm:ss',
    dateFormatWithoutTime: 'YYYY-MM-DD'
  }
} as const
